import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { ToolModeToggle } from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Base64URLDecode, Base64URLEncode } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function Base64URL() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'Base64URL Encoder/Decoder', Iconpath: "/link.svg" };
    const [mode, setMode] = useState("encode");


    


    useEffect(() => {
        setText("")
        setresult("")
    }, [mode]);

    



    const lineCount = (text || "").split("\n").length;
    const resultLineCount = (result ?? "").toString().split("\n").length;

    const handleChange = async (e) => {
        const value = e.target.value;
        setText(value);
    };

    const getResult = async (value) => {
        if (mode === "encode") {
            try {
            const response = await Base64URLEncode({ input: value });
            setresult(response.data.base64url);
            } catch (error) {
                console.error("Error:", error.response?.data?.message);
                setresult("Error: " + (error.response?.data?.message || error.message)  );
                
            }   
        } else {
            try {
                const response = await Base64URLDecode({ input: value });
                setresult(response.data.decoded);
            } catch (error) {
                console.error("Error:", error.response?.data?.message);
                setresult("Error: " + (error.response?.data?.message || error.message));
            }
        }
    };

    const Execute = async () => {
        if(text.trim() === "") {
            setresult("");
            return;
        }
        getResult(text);
    }
     const importFile = (fileContent) => {
        setText(fileContent);
    };

    const pasteExample = () => {
        let exampleValue = "";

        if (mode === "encode") {
            exampleValue = "https://dev.cobygo.in/";
        } else {
            exampleValue = "aHR0cHM6Ly9kZXYuY29ieWdvLmluLw";
        }
        setText(exampleValue);
    };

    return (
        <>
            <Col>
                <ToolHeader title="Base64URL Encoder/Decoder" description="Encode text to Base64 or decode Base64 strings back into readable text" toolFav={toolFav} />

                <ToolModeToggle
                    options={[
                        { label: "Encode", value: "encode", className: "encode" },
                        { label: "Decode", value: "decode", className: "decode" }
                    ]}
                    activeValue={mode}
                    onChange={setMode}
                />
                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder={mode === "encode" ? "Paste text to encode.." : "Paste text to decode.."}
                            lineCount={lineCount}
                            panelStyle={{ width: "100%" }}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    executeLabel={mode === "encode" ? "Encode" : "Decode"}
                                    showExecute={true}
                                    onExecute={Execute}
                                    onImport={(fileContent) => importFile(fileContent)}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Output"
                            value={result ?? ""}
                            placeholder="Output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            panelStyle={{ width: "100%" }}
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={`${mode === "encode" ? "base64url-encode" : "base64url-decode"}.txt`}
                                    mimeType="text/plain;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default Base64URL;
